import { LEGEND_POSITIONS } from "@similarweb/pro-logic-components";

import { translate } from "app/filters/i18nFilter";
import { percentageSignFilter } from "app/filters/ngFilters";
import type { IViewModeData } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/overview-report/model-comparison/types";
import { EViewMode } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/overview-report/model-comparison/types";

export const MAX_SELECTED_BRANDS = 7;
export const MIN_DAYS_FOR_WEEKLY_GRANULARITY = 14;

export const getSharedLegendProps = () => ({
    shouldPresentLegend: true,
    shouldPresentValueAtLegend: true,
    isSelectableCheckboxes: true,
    isLegendSearch: true,
    legendSearchPlaceholder: translate("llm.llm-comparison.graph.search.placeholder"),
    disabledLegendItemTooltip: translate("checkbox.max.selection"),
    isToggleAllEnabled: true,
    legendsMaxWidth: 285,
    legendsHeight: "200px",
    legendHeaders: [
        translate("llm.llm-comparison.graph.legend.header.brands"),
        translate("llm.llm-comparison.graph.legend.header.metric"),
    ] as [string, string],
    legendPosition: LEGEND_POSITIONS.RIGHT,
    maxLegendItemsSelected: MAX_SELECTED_BRANDS,
    keepSameLegendsOnDataUpdate: false,
});

export const VIEW_MODE_CONFIG: Record<EViewMode, IViewModeData> = {
    [EViewMode.Visibility]: {
        displayNameKey: "llm.llm-comparison.item.visibility",
        displayValueFilter: (value: number) => percentageSignFilter()(value, 0),
        yAxis: {
            formatter: (value: number) => percentageSignFilter()(value, 0),
            tickInterval: 0.25,
        },
    },
    [EViewMode.Sentiment]: {
        displayNameKey: "llm.llm-comparison.item.sentiment",
        displayValueFilter: (value: number) => value.toFixed(2),
        yAxis: {
            formatter: (value: number) => value.toString(),
            tickInterval: 0.5,
            dataRange: {
                min: -1,
                max: 1,
            },
        },
    },
    [EViewMode.VisibilityOvertime]: {
        displayNameKey: "llm.llm-comparison.item.visibility_overtime",
        displayValueFilter: (value: number) => percentageSignFilter()(value, 0),
        yAxis: {
            formatter: (value: number) => percentageSignFilter()(value, 0),
            tickInterval: 0.25,
        },
    },
};
